import {VpcService} from "@inter-ikea-kompis/services"
import {IDexfSettings, IVpcConfiguration} from "@inter-ikea-kompis/types"

export default class VPCConfiguration {
  public getConfiguration(
    code: string,
    dexfSettings: IDexfSettings
  ): Promise<IVpcConfiguration | null> {
    const configurationService = new VpcService({
      // Application name used when storing and loading VPC configurations
      applicationName: "DEKIS",

      // DEXF application ID used when storing and loading VPC configurations from DEXF.
      // Will fallback to "applicationName" if not specified.
      dexfApplicationId: "DEKIS",

      // DEXF VPC Configuration version.
      // Will default to "1.0" if not specified.
      dexfConfigurationVersion: "1.0",

      //Dexf settings
      settings: dexfSettings,

      //Dexf API key for the application
      dexfApiKey: "ed299ee2-a032-4b71-8e9d-75c74144d1d6",
    })
    return configurationService.getConfiguration(code)
  }
}
